import { lazy } from "react";

export const CreatorCompleteProfile = lazy(() => import("./CreatorCompleteProfile"));
export const CreatorCompleteProfileV1 = lazy(() => import("./CreatorCompleteProfileV1"));
export const CreatorsProfile = lazy(() => import("./CreatorsProfile"));
export const CreatorsSetting = lazy(() => import("./CreatorsSetting"));

